'use strict';

export class ewModel
{

	setupItemData(data){
		this.beforeSetup(data);
		for(let i in data){
			this[i] = data[i];
		}
		this.afterSetup(data);
	}
	
	beforeSetup(data){
		
	}
	
	afterSetup(data){
		
	}
	
	getValue(name){
		if(typeof(this[name]) !== 'undefined' && this[name] !== ''){
			return this[name];
		}
		return null;
	}
}

